<template>
  <div>
  <div v-if="!isMobile" style="max-width: 1200px;margin:0 auto">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/robot'}" :replace="false">{{ items.robot_type == 'bn'?'Binance':'OKX' }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('robot.strategy_details') }}<span v-if="items.rank" style="display: inline-block;margin-left: 10px">(NO.{{items.rank<10?'0'+items.rank:items.rank}})</span></el-breadcrumb-item>
    </el-breadcrumb>

    <el-card style="margin-top: 12px" shadow="hover">
      <div class="detail_title">
        <img src="../../assets/img/robot/robot_strategy/strategy_martin.svg">
        <span>{{ items.coin_one }} <span style="display:inline-block;vertical-align:middle;font-size: 18px;margin-top:0px;color: #AB54DB">⇀</span> {{ items.coin_two }}</span>
        <span>{{ $t('robot.semi') }}：{{ $t('robot.martin_strategy') }}</span>
        <img v-if="robotState == '1' && details.state == 0" src="../../assets/img/robot/running.gif">
        <span>{{ $t('robot.create_time') }} {{ items.add_time }}</span>
        <div>
          <el-button v-if="details.state <= 1" class="detail_title_button_w" @click="delet(details)">{{ $t('robot.stop_strategy') }}</el-button>
          <el-button v-else class="detail_title_button_w" @click="Restart(items)">{{ $t('robot.restart_strategy') }}</el-button>
<!--          <el-button v-if="details.state == 0" class="detail_title_button_b" @click="startAndStopThis(details, 2)">暫停策略</el-button>-->
<!--          <el-button v-if="details.state == 1" class="detail_title_button_b" style="background-color: #52C41A" @click="startAndStopThis(details, 1)">開啓策略</el-button>-->
        </div>
      </div>
    </el-card>

    <el-card class="total_revenue" style="margin-top: 0px;position: relative" shadow="hover">
      <div class="total_revenue_content" style="width: 100%">
        <div style="display: flex; justify-content: space-between">
          <div style="display: inline-block; width: 25%;">
            <span style="margin-bottom: 8px;display: block">{{ $t('robot.Total_revenue') }}(USDT)</span>
            <span style="font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #1E2329;">{{ details.profit_total | roundEightFilter }}</span>
          </div>
          <div style="display: inline-block; width: 25%;text-align: left;padding-right: unset">
            <span style="margin-bottom: 8px;display: block">{{ $t('robot.total_profit') }}(USDT)</span>
            <span style="font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #1E2329;">{{ details.profit_all | roundEightFilter }}</span>
          </div>
          <div style="display: inline-block; width: 25%;text-align: unset">
            <span style="margin-bottom: 8px;display: block">{{ $t('robot.floating_profit_loss') }}(USDT)</span>
            <span style="font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #1E2329;">{{ details.profit_loss | roundEightFilter }}</span>
          </div>
          <div class="" style="display: inline-block; width: 25%; text-align: right">
            <span style="margin-bottom: 8px">{{ $t('robot.yield') }} | {{ $t('robot.total_annualization') }}</span>
            <span v-if="details.profit_rate >= 0" style="font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #52C41A;">{{ details.profit_rate | roundEightFilter }}% | {{ details.profit_rate_year | roundEightFilter }}%</span>
            <span v-if="details.profit_rate < 0" style="font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #FF4D4F;">{{ details.profit_rate | roundEightFilter }}% | {{ details.profit_rate_year | roundEightFilter }}%</span>
          </div>
        </div>
        <div style="width: 100%;height: 1px;background: #EAECEF;margin: 20px 3% 20px 0"></div>
        <div style="width: 100%; position:relative;color: #72777E">
          <div style="display: inline-block;width: 25%;vertical-align: middle;">
            <span style="margin-bottom: 8px">{{ $t('robot.input_amount') }}(U)</span>
            <span class="total_revenue_content_bottom" style="color: #1E2329">{{ details.fund?$options.filters['roundEightFilter'](details.fund):0 }} USDT</span>
          </div>
          <div style="display: inline-block;width: 25%;vertical-align: middle;">
            <span style="margin-bottom: 8px">{{ $t('robot.average_position_price') }}(U)</span>
            <span class="total_revenue_content_bottom" style="color: #1E2329">{{ details.average_price?details.average_price:0 }} USDT</span>
          </div>
<!--          <div style="display: inline-block;width: 25%;vertical-align: middle;">-->
<!--            <span style="margin-bottom: 8px">當前循環</span>-->
<!--            <span class="total_revenue_content_bottom" style="color: #1E2329">第{{ details.current_number_of_cycles }}次</span>-->
<!--          </div>-->
          <div style="display: inline-block;width: 25%;vertical-align: middle;">
            <span style="margin-bottom: 8px">{{ $t('robot.done') }}</span>
            <span class="total_revenue_content_bottom" style="color: #1E2329">{{ (details.current_order_no==1)?$t('robot.first_order'):details.current_order_no?$t('robot.di')+details.current_order_no+$t('robot.order'):'0'+$t('robot.order') }}</span>
          </div>
<!--          <el-button class="detail_title_button_w" style="width: 16%;margin-right: 3%;vertical-align: middle;">查看排行</el-button>-->
        </div>
      </div>
<!--      <div class="total_revenue_content" style="height:170px;border-left: 1px #EAECEF solid;padding-left: 1%;">-->
<!--        <charts-line></charts-line>-->
<!--      </div>-->
    </el-card>

    <el-card class="total_revenue" style="margin-top: 0px;position: relative" shadow="hover">
      <div class="total_revenue_content" style="width: 100%">
        <span style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #1E2329;">{{ $t('robot.strategy_details') }}</span>
        <div style="width: 100%;height: 1px;background: #EAECEF;margin: 16px 3% 16px 0"></div>
        <div class="celue_detail_base_set" style="display: flex; justify-content: space-between;margin-top: 16px;width: unset">
          <div style="display: inline-block;width: 18%">
            <span style="display: block">{{ $t('robot.policy_type') }}</span>
            <span style="color: #1E2329;margin-top: 3px">{{ details.strategy_type_name }}</span>
          </div>
          <div style="display: inline-block;width: 13.6%">
            <span style="display: block">{{ $t('robot.trend_cycle') }}</span>
            <span v-if="details.trend_cycle_switch == 1" style="display:block; color: #1E2329">{{ $t('robot.closed') }}</span>
            <span v-else style="color: #1E2329;margin-top: 3px">{{ details.trend_cycle?details.trend_cycle:0 }}{{ $t('robot.minutes') }}</span>
          </div>
          <div style="display: inline-block;width: 13.6%">
            <span style="display: block">{{ $t('robot.first_order_limit') }}(U)</span>
            <span style="color: #1E2329;margin-top: 3px">{{ details.space?details.space:0 }} USDT</span>
          </div>
          <div style="display: inline-block;width: 13.6%">
            <span style="display: block">{{ $t('robot.replenishment_times') }}</span>
            <span style="color: #1E2329;margin-top: 3px">{{ details.billing_quantity?(Number(details.billing_quantity)-1):0 }}</span>
          </div>
          <div style="display: inline-block;width: 13.6%">
            <span style="display: block">{{ $t('robot.times_of_cycles') }}</span>
            <span style="color: #1E2329;margin-top: 3px">{{ details.number_of_cycles>0?details.number_of_cycles:$t('robot.infinite')}}</span>
          </div>
          <div style="display: inline-block;width: 13.6%">
            <span style="display: block">{{ $t('robot.stop_ratio') }}</span>
            <span style="color: #1E2329;margin-top: 3px">{{ details.stop_ratio?details.stop_ratio:0 }}%</span>
          </div>
          <div style="display: inline-block;width: 13.6%">
            <span style="display: block">{{ $t('robot.full_stop') }}</span>
            <span v-if="details.full_stop == 1" style="display:block; color: #1E2329">{{ $t('robot.closed') }}</span>
            <span v-else style="color: #1E2329;margin-top: 3px">{{ details.stop_loss_ratio?details.stop_loss_ratio:0 }}%</span>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="grid_order" style="margin-top: 0px;position: relative" shadow="hover">
      <div class="" style="width: 100%;position: relative">
        <span style="display:block;font-size: 14px;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #1E2329">{{ $t('robot.shortcut_settings') }}</span>
        <div style="width: 100%;height: 1px;background: #EAECEF;margin: 16px 3% 16px 0"></div>
        <div style="width: 50%;display: inline-flex;justify-content: space-between">
          <div style="text-align: center;cursor: pointer;position:relative;" @click="(details.state==2||details.state==3)?'':dealSet()">
            <div v-show="details.state==2||details.state==3" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>
            <img src="../../assets/img/robot/robot_strategy/quick_set.svg">
            <span style="display: block">{{ $t('robot.transaction_settings') }}</span>
          </div>
<!--          <div style="position:relative;text-align: center;cursor: pointer;" @click="(details.clearance_sale==1&&(details.state==1||details.state==2||details.state==3))?'':(details.stop_replenishment==1)?(dialogStopSupplement = true): openSupplement()">-->
<!--            <div v-show="details.state==1||details.state==2||details.state==3||details.clearance_sale!=1" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>-->
<!--            <img style="" :src="details.stop_replenishment==1?require('../../assets/img/robot/robot_strategy/quick_stop.svg'):require('../../assets/img/robot/robot_strategy/quick_on.svg')">-->
<!--            <span style="display: block">{{ details.stop_replenishment == 1 ? $t('robot.stop_replenishment') : $t('robot.start_replenishment) }}</span>-->
<!--          </div>-->
          <div style="position:relative;text-align: center;cursor: pointer" @click="(details.state==1||details.state==2||details.state==3)?'':dialogClearanceSale = true">
            <div v-show="details.state==1||details.state==2||details.state==3" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>
            <img src="../../assets/img/robot/robot_strategy/quick_sell.svg">
            <span style="display: block">{{ $t('robot.clearance_sale') }}</span>
          </div>
          <div style="position:relative;text-align: center;cursor: pointer" @click="(details.clearance_sale==1&&(details.state==1||details.state==2||details.state==3))?'':dialogReplenish()">
            <div v-show="details.state==1||details.state==2||details.state==3||details.clearance_sale!=1" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>
            <img src="../../assets/img/robot/robot_strategy/quick_buy.svg">
            <span style="display: block">{{ $t('robot.one_click_replenishment') }}</span>
          </div>
        </div>
        <el-divider class="vertical-line" direction="vertical"></el-divider>
        <div style="width: 40%;display: inline-flex;justify-content: space-between;position: absolute;right: 0">
          <div style="text-align: center;vertical-align: middle">
            <span style="display: block">{{ $t('robot.full_stop') }}</span>
            <el-switch class="switch" :disabled="(details.state==2||details.state==3)" v-loading="isLoading1" v-model="fullStop" :validate-event="true" active-text="开" inactive-text="关" active-color="#AB54DB" :active-value="0" :inactive-value="1" @change="fullStopChange"></el-switch>
          </div>
          <div style="text-align: center;vertical-align: middle">
            <span style="display: block">{{ $t('robot.tracking_interference_stop_callback') }}</span>
            <el-tooltip effect="dark" :content="$t('validate.be_about_to_pop')" placement="top">
            <el-switch class="switch" :disabled="(details.state==2||details.state==3) || true" v-loading="isLoading2" v-model="stopSurplus" :validate-event="true" active-text="开" inactive-text="关" active-color="#AB54DB" :active-value="0" :inactive-value="1" @change="stopSurplusChange"></el-switch>
            </el-tooltip>
          </div>
          <div style="text-align: center;vertical-align: middle">
            <span style="display: block">{{ $t('robot.tracking_replenishment_callback') }}</span>
            <el-tooltip effect="dark" :content="$t('validate.be_about_to_pop')" placement="top">
            <el-switch class="switch" :disabled="(details.state==2||details.state==3) || true" v-loading="isLoading3" v-model="TrackReplenishment" :validate-event="true" active-text="开" inactive-text="关" active-color="#AB54DB" :active-value="0" :inactive-value="1" @change="trackReplenishmentChange"></el-switch>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="" shadow="hover">
      <span style="display:block;font-size: 14px;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #1E2329">{{ $t('robot.cyclic_recording') }}</span>
      <div style="width: 100%;height: 1px;background: #EAECEF;margin: 16px 3% 4px 0"></div>
      <div class="robot-pc">
        <el-table class="table_width" :data="dealOrderList" width="100%" style="width: 100%">
          <el-table-column align="left" width="8%" prop="12" :label="$t('robot.times_of_cycles')">
            <template slot-scope="scope">
<!--              <span style="">{{ scope.row.multiplex+1 }} </span>-->
              <span style="">{{ scope.row.num }} </span>
            </template>

          </el-table-column>
          <el-table-column align="left" width="13%" prop="last_deal_time" :label="$t('robot.completion_last_transaction_time')"></el-table-column>
          <el-table-column align="center" width="13%" prop="multiplexOrNumberOfCycles" :label="$t('robot.replenishment_depth')"></el-table-column>
          <el-table-column align="center" width="13%" prop="profitFex" :label="$t('robot.income_amount')">
            <template slot-scope="scope">
              <span :style="'display:block;'+ 'color:'+(scope.row.profit_total==0?'#1E2329':scope.row.profit_total>=0?'#52C41A':'#FF4D4D')">{{ scope.row.profit_total }}USDT</span>
            </template>
          </el-table-column>
<!--          <el-table-column align="center" width="13%" prop="profitFex" :label="$t('robot.yield')">-->
<!--            <template slot-scope="scope">-->
<!--              <span :style="'display:block;'+ 'color:'+(scope.row.profit_rate>=0?'#52C41A':'#FF4D4D')">{{ scope.row.profit_rate }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column align="center" width="13%" prop="profitFex" :label="$t('robot.robot_run_state')">
            <template slot-scope="scope">
              <span v-if="scope.row.state==0" style="display:inline-block;width: 6px; height: 6px;background-color: #F7B91A;border-radius: 50%;vertical-align: middle"></span>
              <span v-else-if="(scope.row.state==2&&scope.row.is_stop_surplus == 0) || (scope.row.profit_total>0 && scope.row.is_stop_surplus == 2)" style="display:inline-block;width: 6px; height: 6px;background-color: #52C41A;border-radius: 50%;vertical-align: middle"></span>
              <span v-else-if="(scope.row.state==2&&scope.row.is_stop_surplus == 1) || (scope.row.profit_total<0 && scope.row.is_stop_surplus == 2)" style="display:inline-block;width: 6px; height: 6px;background-color: #FF4D4D;border-radius: 50%;vertical-align: middle"></span>


              <span v-if="scope.row.state==-1" style="display:inline-block;color: #1E2329;margin-left: 5px">{{ $t('robot.cancelled') }}</span><!-- state -1 已撤單 0 運行中 2 成交 -->
              <span v-else-if="scope.row.is_stop_surplus != 2 && scope.row.is_stop_surplus != 1 && scope.row.is_stop_surplus != 0 && details.state == 1" style="display:inline-block;color: #1E2329;margin-left: 5px">{{ $t('robot.paused') }}</span><!-- state -1 已撤單 0 運行中 2 成交 -->
              <span v-else style="display:inline-block;color: #1E2329;margin-left: 5px">{{ scope.row.state==0?$t('robot.in_progress'): (scope.row.is_stop_surplus == 2)?$t('robot.clearance_sale'):(scope.row.is_stop_surplus == 0)?$t('robot.interference_stop_completed'): $t('robot.stop_loss_complete') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" width="13%" prop="earn" :label="$t('robot.operation')">
            <template slot-scope="scope">
                <span style="color: #AB54DB;font-size: 14px;font-weight: 400;cursor: pointer" @click="showDetails(1,scope.row)">{{ $t('robot.deal_record') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="text-align: right;margin: 24px"
            layout="prev, pager, next"
            @current-change="getDealOrderListToPage"
            :page-size="10"
            :current-page="pageNum"
            :hide-on-single-page="capitalListTotal<=0"
            :total="capitalListTotal">
        </el-pagination>
      </div>
    </el-card>
    <martin_deal_details ref="dialogDetail" :detailsId="items.id"></martin_deal_details>
  </div>
  <div v-else style="">
    <div style="height: 50px;background-color: white;position:relative;">
      <i class="el-icon-arrow-left" style="display:inline-block;font-size: 20px;line-height: 50px;margin-left: 20px" @click="$router.back()"></i>
      <span style="display:inline-block;position: absolute; margin: auto; left: 50%; top: 50%;transform: translate(-50%, -50%);">{{ $t('robot.strategy_details') }}<span v-if="items.rank" style="display: inline-block;margin-left: 5px">(NO.{{items.rank<10?'0'+items.rank:items.rank}})</span></span>
      <img v-if="items.robot_type == 'bn'" style="position: absolute;right: 0;top: 0;width: 20px;height: 22px" src="../../assets/img/robot/binance_sign.svg">
      <img v-if="items.robot_type == 'ok'" style="position: absolute;right: 0;top: 0;width: 20px;height: 22px" src="../../assets/img/robot/okex_sign.svg">
    </div>
    <el-card style="" shadow="hover">
      <div class="detail_title" style="display:inline-block;border-bottom: unset; position: relative;width: 100%;">
        <span style="display:inline-block;font-size: 16px;vertical-align: middle">{{ items.coin_one }} <span style="display:inline-block;vertical-align:middle;font-size: 18px;margin-top:0px;color: #AB54DB">⇀</span> {{ items.coin_two }}</span>
        <span style="color: #AB54DB;background-color: #F4F8FF;padding: 4px 10px;font-size: 14px">{{ $t('robot.martin_strategy') }}</span>
        <img v-if="robotState == '1' && details.state == 0" style="display:inline-block;height: 16px;vertical-align: middle;margin-left: 9px" src="../../assets/img/robot/running.gif">
        <span style="display: block;font-size: 12px;margin-left: 0px;margin-top: 5px">{{ $t('robot.create_time') }} {{ items.add_time }}</span>
        <div style="display: inline-block;position: absolute;right: 0;top: 0">
          <el-button v-if="details.state <= 1" class="detail_title_button_w" style="display: block;margin: 3px;padding: 4px 15px;" @click="delet(details)">{{ $t('robot.stop') }}</el-button>
          <el-button v-else class="detail_title_button_w" style="display: block;margin: 3px;padding: 4px 15px;" @click="Restart(items)">{{ $t('robot.restart') }}</el-button>
<!--          <el-button v-if="details.state == 0" class="detail_title_button_b" style="display: block;margin: 5px 0 0 3px;padding: 4px 16px;" @click="startAndStopThis(details, 2)">{{ $t('robot.pause') }}</el-button>-->
<!--          <el-button v-if="details.state == 1" class="detail_title_button_b" style="display: block;margin: 5px 0 0 3px;padding: 4px 16px;background-color: #52C41A" @click="startAndStopThis(details, 1)">{{ $t('robot.start') }}</el-button>-->
        </div>
      </div>

    </el-card>
    <el-card style="margin-top: 12px;min-height: 500px" shadow="hover">
      <el-tabs style="" v-model="celue_type" @tab-click="celueType">
        <el-tab-pane :label="$t('robot.revenue_details')" name="1"></el-tab-pane>
        <el-tab-pane :label="$t('robot.policy_information')" name="2"></el-tab-pane>
        <el-tab-pane :label="$t('robot.shortcut_settings')" name="3"></el-tab-pane>
        <el-tab-pane :label="$t('robot.cyclic_recording')" name="4"></el-tab-pane>
      </el-tabs>
      <div v-if="celue_type == 1" class="" style="position: relative">
        <span style="font-size: 14px">{{ $t('robot.Total_revenue') }}(<span style="color: #72777E">USDT</span>)</span>
        <span style="display:block;margin-top:6px;font-size: 22px;font-weight: 600">{{  details.profit_total }}</span>
        <div class="" style="position: absolute;top: 0; right: 0; text-align: right">
          <span style="display:block;font-size: 14px; margin-bottom: 0px;">{{ $t('robot.yield') }} | {{ $t('robot.total_annualization') }}</span>
          <span v-if="details.profit_rate >= 0" style="display:block;font-size: 19px;margin-top:6px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #52C41A;padding-right: 0px">{{ details.profit_rate }}% | {{ details.profit_rate_year }}%</span>
          <span v-if="details.profit_rate < 0" style="display:block;font-size: 19px;margin-top:6px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #FF4D4F;padding-right: 0px">{{ details.profit_rate }}% | {{ details.profit_rate_year }}%</span>
        </div>
        <div style="width: 100%;height: 1px;background: #EAECEF;margin: 15px 3% 15px 0"></div>
        <div style="font-size: 14px;position:relative;color: #72777E">
          <span style="position:relative;vertical-align: middle">{{ $t('robot.input_amount') }}</span>
          <span style="display:inline-block; position:absolute;right:0;color: #1E2329">{{ details.fund?details.fund:0 }} USDT</span>
        </div>
        <div style="font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
          <span style="position:relative;vertical-align: middle">{{ $t('robot.average_position_price') }}</span>
          <span style="display:inline-block; position:absolute;right:0;color: #1E2329">{{ details.average_price?details.average_price:0 }} USDT</span>
        </div>
        <div style="font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
          <span style="position:relative;vertical-align: middle">{{ $t('robot.floating_profit_loss') }}</span>
          <span style="display:inline-block; position:absolute;right:0;color: #1E2329">{{ details.profit_loss }} USDT</span>
        </div>
<!--        <div style="font-size: 14px;position:relative;margin-top: 10px;color: #72777E">-->
<!--          <span style="position:relative;vertical-align: middle">已循環</span>-->
<!--          <span style="display:inline-block; position:absolute;right:0;color: #1E2329">{{ details.current_number_of_cycles?details.current_number_of_cycles:0 }}次</span>-->
<!--        </div>-->
        <div style="font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
          <span style="position:relative;vertical-align: middle">{{ $t('robot.done') }}</span>
<!--          <span style="display:inline-block; position:absolute;right:0;color: #1E2329">{{ details.current_order_no?details.current_order_no:0 }}單</span>-->
          <span style="display:inline-block; position:absolute;right:0;color: #1E2329">{{ (details.current_order_no==1)?$t('robot.first_order'):details.current_order_no?$t('robot.di')+details.current_order_no+$t('robot.order'):'0'+$t('robot.order') }}</span>
        </div>
      </div>
      <div v-if="celue_type == 2" class="" style="font-size: 14px">
        <div>
          <div style="display:inline-block;font-size: 14px;position:relative;margin-top:0px;color: #72777E;width: 55%">
            <span style="display:block;position:relative;vertical-align: middle">{{ $t('robot.policy_type') }}</span>
            <span style="display:block; color: #1E2329">{{ details.strategy_type_name?details.strategy_type_name:'--' }}</span>
          </div>
          <div style="display:inline-block;width:45%;font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
            <span style="position:relative;vertical-align: middle">{{ $t('robot.first_order_limit') }}</span>
            <span style="display:block; color: #1E2329">{{ details.space?details.space:0 }} USDT</span>
          </div>
        </div>
        <div>
          <div style="display:inline-block;width:55%;font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
            <span style="position:relative;vertical-align: middle">{{ $t('robot.stop_ratio') }}</span>
            <span style="display:block; color: #1E2329">{{ details.stop_ratio?details.stop_ratio:0 }}%</span>
          </div>
          <div style="display:inline-block;width:45%;font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
            <span style="position:relative;vertical-align: middle">{{ $t('robot.full_stop') }}</span>
            <span v-if="details.full_stop == 1" style="display:block; color: #1E2329">{{ $t('robot.closed') }}</span>
            <span v-else style="display:block; color: #1E2329">{{ details.stop_loss_ratio?details.stop_loss_ratio:0 }}%</span>
          </div>
        </div>
        <div>
          <div style="display:inline-block;width:55%;font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
            <span style="position:relative;vertical-align: middle">{{ $t('robot.times_of_cycles') }}</span>
            <span style="display:block; color: #1E2329">{{ details.number_of_cycles>0?details.number_of_cycles:$t('robot.limitless')}}</span>
          </div>
          <div style="display:inline-block;width:45%;font-size: 14px;position:relative;margin-top: 10px;color: #72777E">
            <span style="position:relative;vertical-align: middle">{{ $t('robot.replenishment_times') }}</span>
            <span style="display:block; color: #1E2329">{{ details.billing_quantity?(Number(details.billing_quantity)-1):0 }}</span>
          </div>
        </div>
        <div>
          <div style="display:inline-block;font-size: 14px;position:relative;margin-top: 10px;color: #72777E;width: 45%">
            <span style="position:relative;vertical-align: middle">{{ $t('robot.trend_cycle') }}</span>
            <span v-if="details.trend_cycle_switch == 1" style="display:block; color: #1E2329">{{ $t('robot.closed') }}</span>
            <span v-else style="display:block; color: #1E2329">{{ details.trend_cycle?details.trend_cycle:0 }}{{ $t('robot.minutes') }}</span>
          </div>
        </div>
      </div>
      <div v-if="celue_type == 3" class="" style="width: 100%;">
        <div style="width: 100%;margin-top:10px;display: flex;justify-content: space-between;font-size: 14px">
          <div style="text-align: center;position: relative" @click="(details.state==2||details.state==3)?'':dealSet()">
            <div v-show="details.state==2||details.state==3" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>
            <img src="../../assets/img/robot/robot_strategy/quick_set.svg">
            <span style="display: block">{{ $t('robot.transaction_settings') }}</span>
          </div>
<!--          <div style="position:relative;text-align: center" @click="(details.clearance_sale==1&&(details.state==1||details.state==2||details.state==3))?'':details.stop_replenishment==1?dialogStopSupplement = true: openSupplement()">-->
<!--            <div v-show="details.state==1||details.state==2||details.state==3||details.clearance_sale!=1" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>-->
<!--            <img :src="details.stop_replenishment==1?require('../../assets/img/robot/robot_strategy/quick_stop.svg'):require('../../assets/img/robot/robot_strategy/quick_on.svg')">-->
<!--            <span style="display: block">{{ details.stop_replenishment==1 ? $t('robot.stop_replenishment') : $t('robot.start_replenishment') }}</span>-->
<!--          </div>-->
          <div style="position:relative;text-align: center" @click="(details.state==1||details.state==2||details.state==3)?'':dialogClearanceSale = true">
            <div v-show="details.state==1||details.state==2||details.state==3" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>
            <img src="../../assets/img/robot/robot_strategy/quick_sell.svg">
            <span style="display: block">{{ $t('robot.clearance_sale') }}</span>
          </div>
          <div style="position:relative;text-align: center" @click="(details.clearance_sale==1&&(details.state==1||details.state==2||details.state==3))?'':dialogReplenish()">
            <div v-show="details.state==1||details.state==2||details.state==3||details.clearance_sale!=1" style="position:absolute;left:0;right:0;top:0;bottom: 0;background-color: rgba(255,255,255,0.7);z-index: 10;"></div>
            <img src="../../assets/img/robot/robot_strategy/quick_buy.svg">
            <span style="display: block">{{ $t('robot.one_click_replenishment') }}</span>
          </div>
        </div>
        <el-divider></el-divider>
        <div style="width: 100%;margin-top:20px;display: flex;justify-content: space-between;font-size: 14px">
          <div style="text-align: center;vertical-align: middle">
            <span style="display: block">{{ $t('robot.full_stop') }}</span>
            <el-switch class="switch" v-model="fullStop" :disabled="(details.state==2||details.state==3)" :validate-event="true" :active-text="$t('robot.open')" :inactive-text="$t('robot.close')" active-color="#AB54DB" :active-value="0" :inactive-value="1" @change="fullStopChange"></el-switch>
          </div>
<!--          <div style="text-align: center;vertical-align: middle">-->
<!--            <span style="display: block">{{ $t('robot.tracking_interference_stop_callback') }}</span>-->
<!--            <el-switch class="switch" v-model="stopSurplus" :disabled="(details.state==2||details.state==3)" :validate-event="true" active-text="开" inactive-text="关" active-color="#AB54DB" :active-value="0" :inactive-value="1" @change="stopSurplusChange"></el-switch>-->
<!--          </div>-->
<!--          <div style="text-align: center;vertical-align: middle">-->
<!--            <span style="display: block">{{ $t('robot.tracking_replenishment_callback') }}</span>-->
<!--            <el-switch class="switch" v-model="TrackReplenishment" :disabled="(details.state==2||details.state==3)" :validate-event="true" active-text="开" inactive-text="关" active-color="#AB54DB" :active-value="0" :inactive-value="1" @change="trackReplenishmentChange"></el-switch>-->
<!--          </div>-->
        </div>
      </div>
      <div v-if="celue_type == 4" class="" style="width: 100%;">
        <div>
          <el-table :data="dealOrderList" :show-header="false" style="width: 100%">
            <el-table-column class="mobile_order" align="left" prop="" label="">
              <template slot-scope="scope">
                  <div style="color: #1E2329;font-weight: 400;position: relative" @click="showDetails(2, scope.row)">
                    <span style="display:inline-block;vertical-align:middle;font-size: 14px;font-weight: 500;;">{{ $t('robot.di') }}{{ scope.row.num }}{{ $t('robot.secondary_cycle') }}</span>
                    <img style="display:inline-block;margin-left: 8px;vertical-align: middle" src="../../assets/img/robot/robot_strategy/go.svg">
                    <div style="position: absolute;right: 0; top: 0">
<!--                      ': scope.row.state == 1? '#FF4D4D':'#52C41A'-->
                      <span v-if="(scope.row.state==0) || (scope.row.profit_total==0 && scope.row.is_stop_surplus == 2)" style="display:inline-block;width: 6px; height: 6px;background-color: #F7B91A;border-radius: 50%;vertical-align: middle"></span>
                      <span v-else-if="(scope.row.state==2&&scope.row.is_stop_surplus == 0) || (scope.row.profit_total>0 && scope.row.is_stop_surplus == 2)" style="display:inline-block;width: 6px; height: 6px;background-color: #52C41A;border-radius: 50%;vertical-align: middle"></span>
                      <span v-else-if="(scope.row.state==2&&scope.row.is_stop_surplus == 1) || (scope.row.profit_total<0 && scope.row.is_stop_surplus == 2)" style="display:inline-block;width: 6px; height: 6px;background-color: #FF4D4D;border-radius: 50%;vertical-align: middle"></span>

                      <span v-if="scope.row.state==-1" style="display:inline-block;color: #1E2329;margin-left: 5px">{{ $t('robot.cancelled') }}</span><!-- state -1 已撤單 0 運行中 2 成交 -->
                      <span v-else-if="scope.row.is_stop_surplus != 2 && scope.row.is_stop_surplus != 1 && scope.row.is_stop_surplus != 0 && details.state == 1" style="display:inline-block;color: #1E2329;margin-left: 5px">{{ $t('robot.paused') }}</span>
                      <span v-else style="display: inline-block;margin-left: 4px;vertical-align: middle">{{ scope.row.state==0?$t('robot.in_progress'): (scope.row.is_stop_surplus == 2)?$t('robot.clearance_sale'):(scope.row.is_stop_surplus == 0)?$t('robot.interference_stop_completed'): $t('robot.stop_loss_complete') }}</span>
                    </div>
                    <div style="margin-top: 10px">
                      <div style="display:inline-block;width: 60%">
                        <span style="display:block;color:#72777E;">{{ $t('robot.completion_last_transaction_time') }}</span>
                        <span style="display:block;">{{ scope.row.last_deal_time }}</span>
                      </div>
                      <div style="display:inline-block;width: 40%">
                        <span style="display:block;color:#72777E;">{{ $t('robot.replenishment_depth') }}</span>
                        <span style="display:block;">{{ scope.row.multiplexOrNumberOfCycles}}</span>
                      </div>
                    </div>
                    <div style="margin-top: 10px">
                      <div style="display:inline-block;width: 60%">
                        <span style="display:block;color:#72777E;">{{ $t('robot.income_amount') }}</span>
                        <span :style="'display:block;'+ 'color:'+(scope.row.profit_total==0?'#1E2329':scope.row.profit_total>0?'#52C41A':'#FF4D4D')">{{ scope.row.profit_total }}USDT</span>
                      </div>
<!--                      <div style="display:inline-block;width: 40%">-->
<!--                        <span style="display:block;color:#72777E;">收益率</span>-->
<!--                        <span :style="'display:block;'+ 'color:'+(scope.row.profit_rate>=0?'#52C41A':'#FF4D4D')">{{ scope.row.profit_rate }}%</span>-->
<!--                      </div>-->
                    </div>
                  </div>
              </template>
            </el-table-column>
          </el-table>
          <span style="font-size:14px; color: #000613; line-height: 22px;">{{ $t('robot.total') }} <span>{{ totalRowofMb }}</span> {{ $t('robot.strip') }}</span>
          <el-pagination
              style="float:right;padding-right: 0px;"
              small
              layout="prev, pager, next"
              @current-change="getDealOrderListToPage"
              :page-size="10"
              :current-page="pageNumofMb"
              :hide-on-single-page="totalRowofMb<=0"
              :total="totalRowofMb">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-drawer
        :title="$t('robot.transaction_details')"
        :visible.sync="semi_drawer2"
        :direction="direction">
      <div style="width: 100%;height: 1px;background: #EAECEF;margin: 10px 3% 10px 0"></div>
      <div v-for="(item, i) in DealOrderDetails" style="padding: 0 20px 20px 20px; font-size: 14px">
        <span style="display:inline-block;font-weight: 500;font-size:16px;color: #1E2329;width: 32%">{{ items.coin_one }}<span v-if="item.side == 'buy'" style="display:inline-block;vertical-align:middle;font-size: 18px;margin-top:0px;color: #52C41A;">⇀</span><span v-if="item.side == 'sell'" style="display:inline-block;vertical-align:middle;font-size: 18px;margin-top:0px;color: #FF4D4F;">↼</span>{{ items.coin_two }}</span>
        <div style="display:inline-block;margin-left: 2px">
          <span v-if="item.side == 'buy'" style="padding: 2px 5px;border-radius:2px;background-color: #ecf8f5;font-weight:0;color:#49b18e;width: fit-content">{{ $t('robot.buy_in') }}</span>
          <span v-else style="padding: 2px 5px;border-radius:2px;background-color: #fcf6f5;font-weight:0;color:#e56980;width: fit-content">{{ $t('robot.sell_out') }}</span>
          <span style="display: inline-block; margin-left: 20px">{{ item.serial_number }}</span>
        </div>
        <div style="margin-top: 5px;color: #72777E;font-weight: unset">
          <div style="display: block">
            <span style="display:inline-block;width:50%;">{{ $t('robot.entrusted_time') }}<span style="display: block;color: #1E2329;font-weight: 500">{{ item.create_time }}</span></span>
            <span style="display:inline-block;width:50%;margin-top: 5px">{{ $t('robot.transaction_time') }}<span style="display: block;color: #1E2329;font-weight: 500">{{ item.deal_time }}</span></span>
          </div>
          <div style="display: block">
            <span style="display:inline-block;width: 50%">{{ $t('robot.transaction_volume') }}({{items.coin_one}})<span style="display: block;color: #1E2329;font-weight: 500">{{item.total_true}}</span></span>
            <span style="display:inline-block;width:50%;margin-top: 5px">{{ $t('robot.average_transaction_price') }}({{items.coin_one}})<span style="display: block;color: #1E2329;font-weight: 500">{{ item.avg_price }}</span></span>
          </div>
          <div style="display: block">
            <span style="display:inline-block;width: 50%">{{ $t('robot.number_of_transactions') }}({{items.coin_two}})<span style="display: block;color: #1E2329;font-weight: 500">{{ item.size }}</span></span>
            <span style="display:inline-block;width:50%;margin-top: 5px">{{ $t('robot.service_charge') }}({{item.side == 'buy'?items.coin_two:items.coin_one}})<span style="display: block;color: #1E2329;font-weight: 500">-{{item.fee_true}}</span></span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>

    <el-dialog
        class="details_dialog"
        :title="robotState != 2? $t('robot.are_you_sure_del_martin'): $t('robot.stop_martin_strategy')"
        :visible.sync="dialogStopState"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        width="500px"
        style="height: auto;overflow: unset;padding-top: 0px">
      <el-divider></el-divider>
      <span v-if="robotState != 2" class="del_grid_span" style="display:inline-block;background-color: #F4F8FF;color: #AB54DB; padding: 10px">{{ $t('robot.stop_martin_tip') }}</span>
<!--      <span v-else style="display:inline-block;margin-top: 10px">{{ $t('robot.stop_martin_tip') }}</span>-->
      <div v-if="robotState != 2" class="" style="margin-top: 30px">
        <el-radio style="display: block" v-model="stopState" label="3">{{ $t('robot.stop_policy_and_cancel_order') }}</el-radio>
        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">{{ $t('robot.strategy_cancel_order_radio2') }}</span>
        <span v-if="stopState == '3'" style="display:block;color: #FF4D4F;margin-left: 23px;margin-top: 3px">{{ $t('robot.strategy_cancel_order_radio2_tip') }}</span>
      </div>
      <div v-if="robotState != 2" class="" style="margin-top: 20px">
        <el-radio v-model="stopState" label="2">{{ $t('robot.stop_strategy_no_cancellation') }}</el-radio>
        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">{{ $t('robot.strategy_no_cancellation_radio2') }}</span>
      </div>
      <span v-if="robotState == 2" style="display:block;color: #606266;margin-top: 6px;">{{ $t('robot.stop_martin_tip_stop') }}</span>
      <span slot="footer" class="dialog-footer">
    <el-button class="robot_btn" type="" style="width: 90px;color: #72777E !important;" @click="dialogStopState = false">{{ $t('robot.cancel') }}</el-button>
    <el-button class="go_and_open" type="primary" style="width: 90px;text-align: center" @click="delMartin()">{{ $t('robot.confirm') }}</el-button>
  </span>
    </el-dialog>

    <el-dialog
        class="details_dialog"
        :title="$t('robot.stop_replenishment')"
        :visible.sync="dialogStopSupplement"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        width="500px"
        style="height: auto;overflow: unset;padding-top: 0px">
      <el-divider></el-divider>
      <span class="del_grid_span" style="display:inline-block;background-color: #F4F8FF;color: #AB54DB; padding: 10px">{{ $t('robot.stop_replenishment_tip') }}</span>
      <div class="" style="margin-top: 20px">
        <el-radio style="display: block" v-model="supplementState" label="0">{{ $t('robot.stop_replenishment_radio1') }}</el-radio>
        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">{{ $t('robot.stop_replenishment_radio1_tip') }}</span>
      </div>
      <div class="" style="margin-top: 20px">
        <el-radio v-model="supplementState" label="2">{{ $t('robot.stop_replenishment_radio2') }}</el-radio>
        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">{{ $t('robot.stop_replenishment_radio2_tip') }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button class="robot_btn" type="" style="width: 90px;color: #72777E !important;" @click="dialogStopSupplement = false">{{ $t('robot.cancel') }}</el-button>
    <el-button class="go_and_open" type="primary" style="width: 90px;text-align: center" @click="stopSupplement()">{{ $t('robot.confirm') }}</el-button>
  </span>
    </el-dialog>

    <el-dialog
        class="details_dialog"
        :title="$t('robot.clearance_sale')"
        :visible.sync="dialogClearanceSale"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        width="500px"
        style="height: auto;overflow: unset;padding-top: 0px">
      <el-divider></el-divider>
      <span class="del_grid_span" style="display:inline-block;background-color: #F4F8FF;color: #AB54DB; padding: 10px">{{ $t('robot.clearance_sale_tip') }}</span>
      <div class="" style="margin-top: 20px">
        <el-radio style="display: block" v-model="clearanceSaleState" label="0">{{ $t('robot.clearance_sale_radio1') }}</el-radio>
        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">{{ $t('robot.clearance_sale_radio1_tip') }}</span>
      </div>
      <div class="" style="margin-top: 20px">
        <el-radio v-model="clearanceSaleState" label="2">{{ $t('robot.clearance_sale_radio2') }}</el-radio>
        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">{{ $t('robot.clearance_sale_radio2_tip') }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button class="robot_btn" type="" style="width: 90px;color: #72777E !important;" @click="dialogClearanceSale = false">{{ $t('robot.cancel') }}</el-button>
    <el-button class="go_and_open" type="primary" style="width: 90px;text-align: center" @click="ClearanceSale()">{{ $t('robot.confirm') }}</el-button>
  </span>
    </el-dialog>

    <el-dialog
        class="details_dialog"
        :title="$t('robot.one_click_replenishment')"
        :visible.sync="dialogReplenishment"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="500px"
        style="height: auto;overflow: unset;padding-top: 0px">
      <el-divider></el-divider>
      <span class="del_grid_span" style="display:inline-block;background-color: #F4F8FF;color: #AB54DB; padding: 10px">{{ $t('robot.one_click_replenishment_tip') }}</span>
      <div class="" style="position:relative;margin-top: 20px">
        <span style="display: block" v-model="stopState" label="3">{{ $t('robot.replenishment_position') }}</span>
        <el-input id="wran_single_grid" @input="checkinput($event, 'spaceNum')" class="sj-sp-coin-name md-in-amount" v-model="spaceNum" style="margin-top: 5px;" :placeholder="$t('robot.input_amount_holder')"></el-input>
        <span style="display:block;position:absolute;right:10px;top:10px;color: #72777E;margin-top: 26px">USDT</span>
      </div>
      <span v-show="parseFloat(this.spaceNum)<parseFloat((this.miniAmount * this.details2 * 1.5).toFixed(3))" style="color: #FF4D4F">{{ $t('robot.replenishment_position_tip1') }}</span>
      <span v-show="parseFloat(this.spaceNum)>this.coinBalance" style="color: #FF4D4F">{{ $t('robot.replenishment_position_tip2') }}</span>
      <span style="display: block; margin-top: 10px;color: #1E2329">{{ $t('robot.available') }}：{{coinBalance | roundTwoFilter}} USDT</span>
      <div class="" style="position:relative;margin-top: 20px">
        <span style="display: block" v-model="stopState" label="3">{{ $t('robot.replenishment_position_price') }}</span>
        <el-input id="replenishment_price" @input="checkinput($event, 'spaceNum')" class="sj-sp-coin-name md-in-amount" v-model="price" style="margin-top: 5px;" :placeholder="$t('robot.input_amount_holder')"></el-input>
        <span style="display:block;position:absolute;right:10px;top:10px;color: #72777E;margin-top: 26px">USDT</span>
      </div>
<!--      <div class="" style="margin-top: 30px">-->
<!--        <el-radio style="display: block" v-model="replenishmentState" label="0">本次循環繼續補倉</el-radio>-->
<!--        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">一鍵補倉后將仍按策略的設置繼續補倉</span>-->
<!--      </div>-->
<!--      <div class="" style="margin-top: 20px">-->
<!--        <el-radio v-model="replenishmentState" label="1">本次循環不再補倉</el-radio>-->
<!--        <span style="display:block;color: #8E9298;margin-left: 23px;margin-top: 3px">一鍵補倉后將不再按策略的設置補倉</span>-->
<!--      </div>-->
      <span slot="footer" class="dialog-footer">
    <el-button class="robot_btn" type="" style="width: 90px;color: #72777E !important;" @click="dialogReplenishment = false">{{ $t('robot.cancel') }}</el-button>
    <el-button class="go_and_open" type="primary" style="width: 90px;text-align: center" @click="replenishment()">{{ $t('robot.confirm') }}</el-button>
  </span>
    </el-dialog>
    <Martin_add_dialog @updateList="initData" ref="MartinAddDialogRef"></Martin_add_dialog>
  </div>
</template>

<script>
import ChartsLine from "./chartsLine";
import {
  clearanceSale,
  delGrid, delMartinStrategy,
  getCoinBalance,
  getDealOrderDetails,
  getDealOrderList,
  getGridStrategy, getMartinDealOrderDetails, getMartinStrategy,
  getNoDealSellOrderList, getStrategyCircleList, getSymbolInfoByCoins,
  getTickerPrice, martinStrategyShortcut, oneClickReplenishment,
  startOrPauseGridStrategy, startOrPauseMartinStrategy, stopReplenishment
} from "../../server/robot";
import Martin_deal_details from "./martin_deal_details";
import {dialogDealDetail, MartinAddDialogMixin} from "../../mixin/mixin";
import Martin_add_dialog from "./martin/Martin_add_dialog";

export default {
  name: "Robot_martin_detail",
  components: {Martin_deal_details, ChartsLine,Martin_add_dialog},
  mixins:[dialogDealDetail,MartinAddDialogMixin],
  data(){
    return{
      isMobile: false,
      isLoading1: false,
      isLoading2: false,
      isLoading3: false,
      value_trade: 0,
      value_total: 0,
      spaceNum: '', //一鍵補倉倉位屬
      price: '', // 當前價格
      dialogStopState: false, //刪除策略 框
      dialogStopSupplement: false, //停止補單 框
      dialogOpenSupplement: false, //開啓補單 框
      dialogClearanceSale: false, //清倉賣出 框
      dialogReplenishment: false, //一件補倉 框
      delGridItem: {}, //刪除網格臨時存儲
      stopState: '3', // 2:不撤單  3：撤單
      supplementState: '0', // 開啓補單
      clearanceSaleState: '0', // 清倉賣出
      replenishmentState: '0', // 一鍵補倉
      DealOrderDetails: [],
      orderId: '',
      switchValue: 2,
      celue_type: '1',
      semi_drawer2: false,
      direction: 'btt',
      items: {},
      runTime: '',
      miniAmount: '0',//可用最小余额
      details:{},
      buyOrderList: [],
      sellOrderList: [],
      details2: '',
      robotType: '',
      robotState: '',
      dealOrderList: [],
      capitalListTotal: 0,
      pageNum: 1,
      totalRow: 0,
      totalRowofMb: 0,
      pageNumofMb: 1,
      requestTimes: 0,
      t:null,
      fullStop: 1,
      stopSurplus: 1,
      TrackReplenishment: 1,
      coinBalance: 0,
    }
  },

  mounted() {
    this.orderId = this.$route.query.id
    this.switchValue = this.$route.query.switchValue;
    this.items = sessionStorage.getItem('detailItem')?JSON.parse(sessionStorage.getItem('detailItem')):{}
    this.robotType = this.$route.query.robotType
    this.robotState = this.$route.query.robotState
    this.getRuntime();
    if (this.$util._isMobile()){
      if (this.$util._isMobile[0] == 'iPad'){
        this.isMobile = false
      }
      this.isMobile = true;
    } else {
      this.isMobile = false
    }
    this.changeScreenSize();
    this.initData();
    // this.setTimers()
  },

  methods:{
    initData(){
      this.getMartinStrategy();
    },

    changeScreenSize(){
      window.addEventListener('resize',()=>{
        const bodyWidth=document.body.clientWidth
        if (bodyWidth>=900) {
          this.isMobile = false
          return
        }
        this.isMobile=true
      })
      const bodyWidth=document.body.clientWidth
      if (bodyWidth>=999) return this.isMobile = false
    },

    celueType(){

    },

    getRuntime(){
      this.runTime = this.$util.formatDuring(new Date().getTime() - new Date(this.items.add_time))
    },

    startAndStopThis(item, num){
      if(num == 1){
        this.startOrPauseMartinStrategy(item.strategy_uid, num);
      }else {
        if (this.details.stop_replenishment == 2 || this.details.clearance_sale == 2){
          this.delTips();
          return;
        }
        this.$confirm(this.$t('robot.you_sure_you_suspend_strategy_martin'))
            .then(async _ => {
              await this.startOrPauseMartinStrategy(item.strategy_uid, num);
            })
            .catch(_ => {});
      }
    },

    // 马丁
    async startOrPauseMartinStrategy(uid, action){
      const res = await startOrPauseMartinStrategy(uid, action)
      if (!res) return;
      if (res.success) {
        if (action == 1) {
          this.$message.success(this.$t('robot.turned_on'))
        } else {
          this.$message.success(this.$t('robot.paused'))
        }
        this.initData()
      } else {
        this.$message.error(res.message)
      }
    },

    async getMartinStrategy() {
      const res = await getMartinStrategy(this.items.strategy_uid, this.requestTimes)
      if (!res) return
      if (res.success){
        this.details = res.data
        this.value_total = this.details.grid_number
        this.details.coinOne = this.details.coin.split('-')[0]
        this.details.coinTwo = this.details.coin.split('-')[1]
        if (this.details.strategy_type == 0){
          this.details.strategy_type_name = this.$t('robot.strategy_type_name0')
        } else if(this.details.strategy_type == 1){
          this.details.strategy_type_name = this.$t('robot.strategy_type_name1')
        } else if(this.details.strategy_type == 2){
          this.details.strategy_type_name = this.$t('robot.strategy_type_name2')
        }
        this.fullStop = this.details.full_stop;
        this.stopSurplus = this.details.tracking_stop;
        this.TrackReplenishment = this.details.track_replenishment;
        if (this.pageNumofMb == 1 || this.pageNum == 1) {
          await this.getDealOrderList(this.isMobile ? this.pageNumofMb : this.pageNum);
        }
      }else {
        this.$message.error(res.message)
      }
    },

    async getTickerPrice(){
      const res = await getTickerPrice(this.items.coin, this.robotType, this.requestTimes)
      if (!res) return
      if (res.success){
        if (!res.data) return
        this.details2 = res.data
        this.price = this.details2
        document.getElementById('replenishment_price').placeholder = this.$t('robot.current_price')+'：' + this.details2
        await this.getSymbolInfoByCoins()
      }else {
        this.$message.error(res.message)
      }
    },

    getDealOrderListToPage(num){
      this.requestTimes = 0
      this.getDealOrderList(num)
    },

    async getDealOrderList(num){
      this.pageNumofMb = num;
      this.pageNum = num;
      const res = await getStrategyCircleList(this.items.strategy_uid, this.isMobile?this.pageNumofMb:this.pageNum, 10, this.requestTimes)
      if (!res) return
      if (res.success){
        if (!res.data) return
        this.totalPageofMb = res.data.totalPage
        this.totalRowofMb = res.data.totalRow
        this.totalRow = res.data.totalPage
        this.capitalListTotal = res.data.totalRow
        this.dealOrderList = res.data.list
        // this.dealOrderList = [{"side":"buy","create_time":"2021-12-24 01:25:05","deal_time":"2021-12-28 09:42:25","instrument_id":"ETHUSDT","buy_order_id":"7170440494","size":0.0036963000,"user_id":3668,"price":3978.0000000000,"sell_order_id":"0","profit_old":0E-20,"id":1256,"state":"2","profit":0},{"side":"buy","create_time":"2021-12-24 01:43:25","deal_time":"2021-12-28 09:39:08","instrument_id":"ETHUSDT","buy_order_id":"7170635739","size":0.0036963000,"user_id":3668,"price":3998.5000000000,"sell_order_id":"0","profit_old":0E-20,"id":1261,"state":"2","is_stop_surplus":0,"profit":0},{"side":"buy","create_time":"2021-12-27 05:48:26","deal_time":"2021-12-28 08:06:01","instrument_id":"ETHUSDT","is_stop_surplus":1,"buy_order_id":"7199751068","size":0.0036963000,"user_id":3668,"price":4019.0000000000,"sell_order_id":"0","profit_old":0E-20,"id":1416,"state":"2","profit":0},{"side":"buy","create_time":"2021-12-27 18:09:19","deal_time":"2021-12-28 07:21:37","instrument_id":"ETHUSDT","buy_order_id":"7203506507","size":0.0036963000,"user_id":3668,"price":4039.5000000000,"sell_order_id":"0","profit_old":0E-20,"id":1459,"state":"2","profit":0},{"side":"sell","create_time":"2021-12-27 16:57:18","deal_time":"2021-12-27 18:09:19","instrument_id":"ETHUSDT","buy_order_id":"7197581167","size":0.0035964000,"user_id":3668,"price":4060.0000000000,"sell_order_id":"7203104050","profit_old":-0.32981985000000000000,"id":1510,"state":"2","profit":-0.3298198500},{"side":"sell","create_time":"2021-12-27 05:47:50","deal_time":"2021-12-27 05:48:26","instrument_id":"ETHUSDT","buy_order_id":"7183617250","size":0.0035964000,"user_id":3668,"price":4039.5000000000,"sell_order_id":"7199745733","profit_old":-0.32777190000000000000,"id":1473,"state":"2","profit":-0.3277719000},{"side":"sell","create_time":"2021-12-26 19:35:32","deal_time":"2021-12-26 23:16:41","instrument_id":"ETHUSDT","buy_order_id":"7196134322","size":0.0035964000,"user_id":3668,"price":4060.0000000000,"sell_order_id":"7196276053","profit_old":-0.32981985000000000000,"id":1454,"state":"2","profit":-0.3298198500},{"side":"sell","create_time":"2021-12-26 11:38:54","deal_time":"2021-12-26 19:09:05","instrument_id":"ETHUSDT","buy_order_id":"7190124668","size":0.0035964000,"user_id":3668,"price":4060.0000000000,"sell_order_id":"7193653721","profit_old":-0.32981985000000000000,"id":1444,"state":"2","profit":-0.3298198500},{"side":"sell","create_time":"2021-12-26 01:58:21","deal_time":"2021-12-26 01:58:52","instrument_id":"ETHUSDT","buy_order_id":"7189920258","size":0.0035964000,"user_id":3668,"price":4060.0000000000,"sell_order_id":"7190120234","profit_old":-0.32981985000000000000,"id":1432,"state":"2","profit":-0.3298198500},{"side":"sell","create_time":"2021-12-26 01:25:49","deal_time":"2021-12-26 01:33:49","instrument_id":"ETHUSDT","buy_order_id":"7187860886","size":0.0035964000,"user_id":3668,"price":4060.0000000000,"sell_order_id":"7189844732","profit_old":-0.32981985000000000000,"id":1431,"state":"2","profit":-0.3298198500}]
        for (let i=0; i<this.dealOrderList.length; i++){
          this.dealOrderList[i].multiplexOrNumberOfCycles = this.dealOrderList[i].state == 0 || this.dealOrderList[i].state == -1 ? this.dealOrderList[i].order_size +'/'+  (this.details.billing_quantity) : this.dealOrderList[i].order_size
          this.dealOrderList[i].num =res.data.totalRow- ((res.data.pageNumber-1)*res.data.pageSize)-i
          // this.dealOrderList[i].profitFex = this.dealOrderList[i].profit.toFixed(2) == 0?'--':this.dealOrderList[i].profit.toFixed(2)
          // this.dealOrderList[i].year = (this.dealOrderList[i].deal_time).split(' ')[0]
          // this.dealOrderList[i].time = (this.dealOrderList[i].deal_time).split(' ')[1]
        }
      } else {
        this.$message.error(res.message)
      }
    },
    handleRecommendCurrentChange(){

    },

    async showDetails(num,item){
      if (num == 1) {
        this.$refs.dialogDetail.dialogItem(true, item)
      }else{
        this.DealOrderDetails = []
        console.log(item.multiplex, item.number_of_cycles)
        const res = await getMartinDealOrderDetails(item.strategy_uid, item.multiplex, item.number_of_cycles);
        if (!res) return;
        if (res.success){
          if (!res.data) return
          this.DealOrderDetails = res.data
          for (let i=0; i<this.DealOrderDetails.length; i++){
            // if (this.DealOrderDetails[i].side == 'sell'){
            //   this.DealOrderDetails[i].charge = (this.DealOrderDetails[i].price * this.DealOrderDetails[i].size * 0.0008).toFixed(8)
            // } else {
            //   this.DealOrderDetails[i].charge = (this.DealOrderDetails[i].size * 0.0008).toFixed(8)
            // }
            // this.DealOrderDetails[i].total = (this.DealOrderDetails[i].price*this.DealOrderDetails[i].size).toFixed(2)
            // this.DealOrderDetails[i].coinOne = this.DealOrderDetails[i].instrument_id.split('-')[0]
            // this.DealOrderDetails[i].coinTwo = this.DealOrderDetails[i].instrument_id.split('-')[1]
            // this.DealOrderDetails[i].transactionVolume = (this.DealOrderDetails[i].price*this.DealOrderDetails[i].size).toFixed(2)
            if(this.DealOrderDetails[i].side == 'buy'){
              if (this.DealOrderDetails[i].robot_id == 0){
                this.DealOrderDetails[i].serial_number = this.$t('robot.one_click_replenishment')
              } else if (this.DealOrderDetails[i].robot_id == 1){
                this.DealOrderDetails[i].serial_number = this.$t('robot.first_order')
              } else {
                this.DealOrderDetails[i].serial_number = this.$t('robot.di')+ (parseInt(this.DealOrderDetails[i].robot_id) - 1) + this.$t('robot.ci') + this.$t('robot.replenishment')
              }
            } else if(this.DealOrderDetails[i].side == 'sell'){
              if (this.DealOrderDetails[i].is_stop_surplus == 0){
                this.DealOrderDetails[i].serial_number = this.$t('robot.interference')
              } else if (this.DealOrderDetails[i].is_stop_surplus == 1){
                this.DealOrderDetails[i].serial_number = this.$t('robot.loss')
              } else {
                this.DealOrderDetails[i].serial_number = this.$t('robot.clearance_sale')
              }
            }
          }
          this.semi_drawer2 = true
        }else {
          this.$message.error(res.message)
        }
      }
    },

    delet(item) {
      this.dialogStopState = true;
      this.delGridItem = item;
    },

    delTips(){
      let msg = '';
      if (this.details.stop_replenishment == 2){
        msg=this.$t('robot.policy_will_stop_completed')
      }
      if (this.details.clearance_sale == 2){
        msg=this.$t('robot.policy_will_stop_clearance_sale')
      }
      this.$confirm(msg,{
        confirmButtonText: this.$t('robot.i_know'),
        showCancelButton:false
      }).then(async _ => {
      }).catch(_ => {});
    },

    async delMartin(){
      if (this.robotState == 2){
        this.stopState = '2'
      }
      const res = await delMartinStrategy(this.delGridItem.strategy_uid, this.stopState)
      if (res.success) {
        this.$message.success(this.$t('robot.del_success'))
        this.dialogStopState = false;
        // await this.getGridStrategy();
        this.$router.back()
      } else {
        this.dialogStopState = false;
        this.$message.error(res.message)
      }
    },

    async getCoinBalance(){ // 獲取可用餘額
      const res = await getCoinBalance(this.items.coin_one, this.robotType);
      if (!res) return;
      if (res.success){
        if (!res.data) return;
        this.coinBalance = res.data
      }
    },

    setTimers(){
      this.t = setInterval(()=>{
        this.requestTimes = 10;
        this.initData()
      },30000)
    },

    dealSet(){
      // this.$message.error('交易設置')
      // if (this.details.state == 0){
      //   this.$confirm('修改交易設置需要先停止該策略',{
      //     confirmButtonText: '我知道了',
      //     showCancelButton: false
      //   }).then(async _ => {
      //     // this.$message.error('去暫停策略')
      //   })
      //       .catch(_ => {});
      //   return;
      // }
      sessionStorage.setItem('robotType', this.robotType)
      sessionStorage.setItem('alertDetails', JSON.stringify(this.details));
      this.handleShowMartinAddDialog(JSON.stringify(this.details))
    },

    stopSupplement(){
      // this.$message.error('停止補單')
      if (this.details.stop_replenishment != 1){
        this.$message.warning(this.$t('robot.stop_supplement_isrunning'))
        return;
      }
      this.stopReplenishment(this.supplementState)
    },

    openSupplement(){
      this.$confirm(this.$t('robot.open_supplement_open_tip'),{
        confirmButtonText: this.$t('robot.sure')
      }).then(async _ => {
        await this.stopReplenishment(1)
        // this.$message.error('開啓補單')
          })
          .catch(_ => {});
    },

    async stopReplenishment(action){ //停止or开启补单 0仅本次循环停止补单，1开启补单，2本次循环停止补单并停止策略
      const res = await stopReplenishment(this.details.strategy_uid, action)
      if (!res) return
      if (res.success){
        this.dialogStopSupplement = false;
        if (action == 1){
          this.$message.success(this.$t('robot.supplement_opened'))
        }else{
          this.$message.success(this.$t('robot.operation_success'))
        }
        this.initData()
      }else{
        this.$message.error(res.message)
      }
    },

    dialogReplenish(){
      this.spaceNum = '';
      this.price='';
      this.getCoinBalance()
      this.getTickerPrice()
      this.dialogReplenishment = true;
    },

    async ClearanceSale() { // 清仓卖出 0仅本次循环清仓卖出，2本次循环清仓卖出并停止策略
      // this.$message.error('清倉賣出')
      if (this.details.clearance_sale!=1){
        this.$message.warning(this.$t('robot.stop_supplement_isrunning'))
        return;
      }
      const res = await clearanceSale(this.details.strategy_uid, this.clearanceSaleState);
      if (!res) return;
      if (res.success) {
        this.dialogClearanceSale = false;
        this.$message.success(this.$t('robot.set_success'))
        this.initData()
      } else {
        this.$message.error(res.message)
      }
    },

    async replenishment(){
      // this.$message.error('一鍵補倉')
      if (this.details.one_click_replenishment!=1){
        this.$message.warning(this.$t('robot.stop_supplement_isrunning'))
        return;
      }
      if (!this.spaceNum || parseFloat(this.spaceNum) == 0){
        this.$message.warning(this.$t('robot.input_replenishment_position'))
        return;
      }
      if (parseFloat(this.spaceNum)<parseFloat((this.miniAmount * this.details2 * 1.5).toFixed(3))){
        this.$message.warning(this.$t('robot.replenishment_position_tip1')+'：'+ (this.miniAmount * this.details2 * 1.5).toFixed(3))
        return;
      }
      if(parseFloat(this.spaceNum)>this.coinBalance){
        this.$message.warning(this.$t('robot.replenishment_position_tip2'))
        return;
      }
      const res = await oneClickReplenishment(this.details.strategy_uid, this.replenishmentState, this.spaceNum, this.price)
      if (!res) return;
      if (res.success) {
        this.dialogReplenishment = false;
        this.$message.success(this.$t('robot.set_success'))
        this.initData()
      } else {
        this.$message.error(res.message)
      }
    },

    fullStopChange(val){
      this.isLoading1 = true
      this.martinStrategyShortcut(1);
    },

    stopSurplusChange(val){
      this.isLoading2 = true
      this.martinStrategyShortcut(2);
    },

    trackReplenishmentChange(val){
      this.isLoading3 = true
      this.martinStrategyShortcut(3);
    },

    async martinStrategyShortcut(action){ // 1满单止损，2追踪止盈，3追踪补仓
      const res = await martinStrategyShortcut(this.details.strategy_uid, action);
      if (!res) return;
      if (res.success){
        this.isLoading1 = false
        this.isLoading2 = false
        this.isLoading3 = false
        this.$message.success(this.$t('robot.status_modified_success'))
        this.initData()
      }else{
        switch (action){
          case 1:
            if (this.fullStop == 0) {
              this.fullStop = 1
            } else {
              this.fullStop = 0
            }
            break;
          case 2:
            if (this.stopSurplus == 0) {
              this.stopSurplus = 1
            } else {
              this.stopSurplus = 0
            }
            break;
          case 3:
            if (this.TrackReplenishment == 0) {
              this.TrackReplenishment = 1
            } else {
              this.TrackReplenishment = 0
            }
            break;
        }
        this.isLoading1 = false
        this.isLoading2 = false
        this.isLoading3 = false
        this.$message.error(res.message)
      }
    },
    checkinput(value, name, num) {       // 通过正则过滤小数点后两位
      const inputValue =
          ("" + value) // 第一步：转成字符串
              .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
              // .replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,"") // 第二步：把不是数字，不是小数点的过滤掉
              .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
              .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
              .match(/^\d*(\.?\d{0,10})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到10位小数
      switch (name) {
        case 'spaceNum':
          this.spaceNum = inputValue
          break;
      }
    },
    async getSymbolInfoByCoins(){
      const res = await getSymbolInfoByCoins(this.details.coinOne, this.details.coinTwo)
      if (!res) return;
      if (res.success){
        if (!res.data) return;
        this.miniAmount = res.data.min_qty
        document.getElementById('wran_single_grid').placeholder = this.$t('robot.replenishment_amount_required')+'≥' + (this.miniAmount * this.details2 * 1.5).toFixed(3)
      } else {
        this.$message.warning(res.message)
      }
    },
    async Restart(item) {
      const res = await getMartinStrategy(item.strategy_uid)
      if (!res) return
      if (res.success) {
        if (res.data){
          var details = res.data
          delete details.strategy_uid
          // sessionStorage.setItem('robotType', this.robotType)
          // this.handleShowMartinAddDialog(2, details);
          sessionStorage.setItem('robotType', this.robotType)
          sessionStorage.setItem('alertDetails', JSON.stringify(details));
          this.handleShowMartinAddDialog(2, JSON.stringify(details))
        }
      } else {
        this.$message.error(res.message)
      }
    },
  },

  destroyed() {
    clearInterval(this.t)
  },
  beforeDestroy() {
    clearInterval(this.t);
    this.t = null;
    // sessionStorage.removeItem('robotType')
    // sessionStorage.removeItem('alertDetails');
    // sessionStorage.removeItem('detailItem')
  }

}
</script>

<style scoped>

.detail_title {
  position: relative;
}

.detail_title img:nth-of-type(1) {
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 7px;
}

.detail_title span:nth-of-type(1) {
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  color: black;
  margin-top: 2px;
  vertical-align: middle;
}

.detail_title span:nth-of-type(2) {
  font-size: 14px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  display: inline-block;
  color: #AB54DB;
  vertical-align: middle;
  background: #F4F8FF;
  padding: 6px 12px;
  border-radius: 2px;
  margin-left: 9px;
}

.detail_title img:nth-of-type(2) {
  width: 14px;
  height: 14px;
  margin-left: 24px;
  vertical-align: middle;
}

.detail_title span:nth-of-type(3) {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #72777E;
  margin-left: 12px;
  vertical-align: middle;
}

.detail_title div {
  display: inline-block;
  position: absolute;
  right: 0px;
}

.detail_title_button_w {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #AB54DB !important;
  padding: 9px 17px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #AB54DB;
}

.detail_title_button_b {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  padding: 10px 18px;
  background: #AB54DB;
  border-radius: 2px;
  border: unset;
}

.total_revenue_content {
  vertical-align: top;
  width: 49%;
  display: inline-block;
}

.total_revenue_content div:nth-of-type(1)>div {
  display: inline-block;
  width: 48.5%;
}

.total_revenue_content div:nth-of-type(1)>div:nth-of-type(2) {
  text-align: right;
  display: inline-block;
  padding-right: 3%;
}

.total_revenue_content span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #72777E;
  display: block;
}

.total_revenue_content_bottom{
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1E2329;
}

.celue_detail_base_set{
  margin-top: 23px;
}

.celue_detail_base_set span{
  display: inline-block;
}

.grid_order span{
  color: #72777E;
  font-size: 14px;
}

.side_color_red {
  color: #FF4D4D
}

.side_color_green {
  color: #52C41A
}

.grid_order_list{
  margin-top: 70px;
}

.grid_order_list table td {
  width: 33%;
  color: #1E2329;
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 2px;
}

>>>.el-tabs__nav-wrap::after{
  height: 1px;
}

>>>.el-tabs__item.is-active {
  color: #AB54DB;
}

>>>.el-tabs__active-bar{
  background-color: #AB54DB;
}

>>>.el-table::before {
  left: 0;
  bottom: 0;
  width: 0;
  height: 0px;
  background-color: unset;
}

@media screen and (max-width: 900px) {
  .robot-pc {
    display: none;
  }

  >>>.el-card__body {
    border-bottom: unset !important;
  }
  >>>.el-tabs__item {
    padding: 0 9px;
  }

  >>>.el-drawer__header{
    color: #1E2329;
  }

  >>>.el-drawer.btt{
    border-radius: 0;
    height: 100% !important;
    right: 0;
    bottom: 0 !important;
    width: 100%;
  }

  .del_grid_span{
    width: 94%;
  }

  .grid_order_list{
    margin-top: 40px;
  }

  >>>.el-table .el-table__cell{
    padding: 5px 0;
  }

  .details_dialog >>>.el-dialog__body{
    margin-top: -10px;
  }
}

@media screen and (min-width: 900px) {
  .robot-pc {
    display: block;
  }
  .details_pc >>>.el-divider {
    margin-top: -20px !important;
  }

  .details_dialog >>>.el-dialog__body{
    /*margin-top: -40px;*/
    padding: 0 20px 30px 20px;
  }

  .del_grid_span{
    width: 95.6%;
  }
}

.table_width >>>.el-table__header, >>>.el-table__body {
  table-layout: fixed;
  border-collapse: separate;
  width: 100% !important;
}

.table_width >>>.el-table__empty-block{
  width: 100% !important;
}

::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  /*background-color: rgba(0, 0, 0, 0.1);*/
  background-color: transparent;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(26, 25, 25, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

>>>.el-radio__inner {
  width: 16px;
  height: 16px;
}
>>>.el-radio__input.is-checked+.el-radio__label {
  color: #1E2329;
}
>>>.el-radio__label{
  color: #1E2329;
}
/* switch按钮样式 */
.switch{
  margin-top: 10px;
}
.switch >>>.el-switch__label {
  position: absolute;
  display: none;
  color: #fff !important;
}
/*打开时文字位置设置*/
.switch >>>.el-switch__label--right {
  z-index: 1;
}
/* 调整打开时文字的显示位子 */
.switch >>>.el-switch__label--right span{
  position: absolute;
  left: -4px;
  top: 5px;
  font-size: 12px;
}
/*关闭时文字位置设置*/
.switch >>>.el-switch__label--left {
  z-index: 1;
}
/* 调整关闭时文字的显示位子 */
.switch >>>.el-switch__label--left span{
  position: absolute;
  right: -35px;
  color: white;
  top: 5px;
  font-size: 12px;
}
/*显示文字*/
.switch >>>.el-switch__label.is-active {
  display: block;
}
/* 调整按钮的宽度 */
.switch.el-switch >>>.el-switch__core,
.el-switch .el-switch__label {
  width: 40px !important;
  margin: 0;
}
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
>>>.el-divider--vertical {
  height: 50px !important;
  margin: 0 50px !important;
}
</style>
